<div class="dds-modal-overlay" (click)="closeModal()"></div>

<div
  ddsResize
  [ngClass]="{
    'dds-modal_lg': size === 'lg',
    'dds-modal_inverse': isInverse
  }"
  class="dds-modal"
>
  <div class="dds-modal__header">
    <span class="dds-modal__title">Attach document(s)</span>
    <dds-button
      size="sm"
      icon="dds-icon_close"
      kind="silent"
      theme="dark"
      ariaLabel="Close modal"
      class="dds-modal__close"
      [isInverse]="isInverse"
      (clicked)="closeModal()"
    ></dds-button>
  </div>
  <div
    *ngIf="showRMReviewedGuidanceNote"
    class="sub-text-section d-flex margin-top-xs relative"
  >
    <span class="icon-s inline-block relative icon-pinned"></span>
    <span>
      <div class="eclipse-header-grey padding-left-xs">
        {{ rmReviewedGuidanceNoteHeader }}
      </div>
      <div
        class="vertical-line-green absolute"
        *ngIf="showRMReviewedGuidanceNote"
      ></div>
    </span>
  </div>
  <div class="padding-left-l">
    <span>
      <div class="margin-top-xs text-gray" *ngIf="showRMReviewedGuidanceNote">
        <div class="eclipse-content-grey">
          {{ rmReviewedGuidanceNoteBody }}
        </div>
      </div>
    </span>
  </div>
  <p *ngIf="validateDocumentAlreadyExists(false)" class="error-message">
    It is impossible to upload the same file
    {{ validateDocumentAlreadyExists(true) }}.
  </p>
  <div class="dds-modal__body">
    <!--TODO: Need to confirm on what will happen if dragndrop visible is false and add attachment true-->
    <div
      class="dds-uploader"
      [ngClass]="{
      'hide-uploader-button': !permissionObj['Intake_Submission_AttachDocument_Enable'],
    }"
    >
      <dds-uploader
        *ngIf="permissionObj['Intake_Submission_DocumentDragAndDrop_Enable']"
        [heading]="uploadAreaOptions.heading ?? ''"
        [description]="uploadAreaOptions.description ?? ''"
        [dragAndDropText]="uploadAreaOptions.dragAndDropText ?? ''"
        [isDragAndDrop]="uploadAreaOptions.isDragAndDrop ?? false"
        [isMultiple]="uploadAreaOptions.isMultiple ?? false"
        [acceptFormats]="uploadAreaOptions.acceptFormats ?? ''"
        [acceptExtensions]="uploadAreaOptions.acceptExtensions ?? ''"
        [exceptSymbols]="uploadAreaOptions.exceptSymbols ?? ''"
        [btnLabel]="uploadAreaOptions.btnLabel ?? ''"
        [isInverse]="uploadAreaOptions.isInverse ?? false"
        [disabled]="uploadAreaOptions.disabled ?? true"
        [chooseFileBtnKind]="uploadAreaOptions.chooseFileBtnKind ?? ''"
        (uploadedItems)="uploadedItems($event)"
      ></dds-uploader>
    </div>
    <div class="div-headers">
      <div class="row d-flex justify-content-evenly">
        <div class="col-md-3 column">
          <span class="div-headers-style">Title</span>
        </div>
        <div class="col-md-2 column">
          <span class="div-headers-style">Type</span>
        </div>
        <div class="col-md-2 column">
          <span class="div-headers-style">Status</span>
        </div>
        <div class="col-md-3 column">
          <span class="div-headers-style">Comment</span>
        </div>
      </div>

      <div class="div-whole-data">
        <span *ngIf="isUploadingInProgress">
          <div
            class="row div-data"
            *ngFor="let row of documentUploadInProgressData"
          >
            <div class="col-md-3 column">
              <span class="div-data-style data-alignment">{{
                row.fileName
              }}</span>
            </div>
            <div class="col-md-3 column">
              <dds-progress
                class="data-alignment"
                [isInverse]="options.isInverse ?? false"
                [description]="options.description ?? ''"
                [isVertical]="options.isVertical ?? false"
                [label]="options.label ?? ''"
                [size]="options.size ?? ''"
                [theme]="options.theme ?? ''"
                [value]="fileUploadPercentage ?? ''"
              ></dds-progress>
            </div>
            <div class="col-md-3 column">
              <span class="uploading-color margin">Uploading in progress</span>
            </div>
            <div class="col-md-1 column">
              <dds-button
                size="sm"
                icon="dds-icon_close"
                kind="silent"
                theme="dark"
                ariaLabel="Close modal"
                class="dds-modal__close"
                [isInverse]="isInverse"
                (clicked)="removeDocument(row)"
              ></dds-button>
            </div>
          </div>
        </span>

        <span>
          <div
            class="row div-data mandatory-margin"
            *ngFor="let row of documentUploadData"
          >
            <div class="file-upload-row d-flex justify-content-evenly">
              <div class="title-section align-items-center d-flex col-md-3">
                <div class="file-name">
                  <span
                    [ddsTooltip]="row.documentTitle"
                    *ngIf="!row.isFileNameInEditMode"
                    >{{ row.documentTitle }}</span
                  >
                  <dds-input
                    class="editing"
                    *ngIf="row.isFileNameInEditMode"
                    [placeholder]="textFileOptions.placeholder ?? ''"
                    [maxLengthPosition]="
                      textFileOptions.maxLengthPosition ?? ''
                    "
                    [size]="textFileOptions.size ?? ''"
                    [(ngModel)]="row.documentTitle"
                  >
                  </dds-input>
                </div>
                <div
                  class="cursor"
                  *ngIf="!row.isFileNameInEditMode"
                  (click)="onFileNameEdit(row)"
                >
                  <img src="assets/dds-icons/pencil-icon.svg" />
                </div>
              </div>

              <div
                [ngClass]="{
                  'dropdown-section-margin': row.documentTypeId !== 0
                }"
                class="dropdown-section align-items-center d-flex col-md-2"
              >
                <span class="icon-own-space">
                  <span
                    [ngClass]="{ 'icon-yellow-hide': row.documentTypeId !== 0 }"
                    class="icon-required-yellow"
                  ></span>
                </span>
                <dds-select
                  class="const-width"
                  [isResponsive]="
                    selectDocumentTypeOptions.isResponsive ?? false
                  "
                  [isRequired]="selectDocumentTypeOptions.isRequired ?? false"
                  [isInverse]="selectDocumentTypeOptions.isInverse ?? false"
                  [list]="documentTypeOptions"
                  [label]="selectDocumentTypeOptions.label ?? ''"
                  [stickerMaxHeight]="'30vh'"
                  [stickerMaxHeight]="'30vh'"
                  [labelPosition]="
                    selectDocumentTypeOptions.labelPosition ?? ''
                  "
                  [customClass]="selectDocumentTypeOptions.customClass ?? ''"
                  [placeholder]="selectDocumentTypeOptions.placeholder ?? ''"
                  [size]="selectDocumentTypeOptions.size ?? ''"
                  [(ngModel)]="row.documentTypeId"
                  [stickerPosition]="
                    selectDocumentTypeOptions.stickerPosition ?? ''
                  "
                  (ngModelChange)="onDocTypeChange(row)"
                >
                </dds-select>
              </div>

              <div
                [ngClass]="{
                  'dropdown-section-margin': row.documentTypeId !== 0
                }"
                class="dropdown-section align-items-center d-flex col-md-2"
              >
                <span class="icon-own-space">
                  <span
                    [ngClass]="{
                      'icon-yellow-hide': row.documentStatusId !== 0
                    }"
                    class="icon-required-yellow col-md-1"
                  ></span
                ></span>
                <dds-select
                  class="const-width"
                  [isResponsive]="selectOptionsStatus.isResponsive ?? false"
                  [isRequired]="selectOptionsStatus.isRequired ?? false"
                  [isInverse]="selectOptionsStatus.isInverse ?? false"
                  [list]="row.documentStatusOptions"
                  [label]="selectOptionsStatus.label ?? ''"
                  [labelPosition]="selectOptionsStatus.labelPosition ?? ''"
                  [customClass]="selectOptionsStatus.customClass ?? ''"
                  [placeholder]="selectOptionsStatus.placeholder ?? ''"
                  [size]="selectOptionsStatus.size ?? ''"
                  [stickerMaxHeight]="'30vh'"
                  [stickerPosition]="selectOptionsStatus.stickerPosition ?? ''"
                  [(ngModel)]="row.documentStatusId"
                  (ngModelChange)="onDocStatusChange(row.documentStatusId)"
                >
                </dds-select>
              </div>

              <div
                class="comment-section align-items-center d-flex padding-left-s col-md-2"
              >
                <span class="icon-own-space">
                  <span
                    [ngClass]="{
                      'icon-required-yellow':
                        row.documentTypeId === otherTypeSelected &&
                        row.comments.length === 0,
                      'icon-yellow-hide': !(
                        row.documentTypeId === otherTypeSelected &&
                        row.comments.length === 0
                      )
                    }"
                    class="col-md-1"
                  ></span
                ></span>
                <dds-input
                  [placeholder]="textareaOptions.placeholder ?? ''"
                  [maxLengthPosition]="textareaOptions.maxLengthPosition ?? ''"
                  [size]="textareaOptions.size ?? ''"
                  [(ngModel)]="row.comments"
                >
                </dds-input>
              </div>

              <div class="close-section">
                <dds-button
                  size="sm"
                  icon="dds-icon_close"
                  kind="silent"
                  theme="dark"
                  ariaLabel="Close modal"
                  class="dds-modal__close close-icon"
                  [isInverse]="isInverse"
                  (clicked)="removeDocument(row)"
                ></dds-button>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
  <div class="dds-modal__footer">
    <div class="dds-modal__footer-content dds-modal__footer-content_left">
      <dds-button
        class="dds-modal__footer-item"
        (clicked)="onSave()"
        (keyboardClicked)="onSave()"
        [disabled]="!isSaveButtonDisabled()"
        >Save</dds-button
      >
      <dds-button
        class="dds-modal__footer-item"
        kind="secondaryLoud"
        [isInverse]="isInverse"
        (clicked)="closeModal()"
        (keyboardClicked)="closeModal()"
        >Cancel</dds-button
      >
    </div>
    <div
      class="dds-modal__footer-content dds-modal__footer-content_right"
    ></div>
  </div>
</div>
